// extracted by mini-css-extract-plugin
module.exports =  {"root":"root--fOXWI","toggle":"toggle--Wi4qA"};